const enums = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    NOT_EXIST: 'not_exist',
};

export default Object.freeze(enums);